class buttonsContainer {
    constructor(container) {
        this.offset = 20;
        this.container = container;
        this.backToTopLink = container.querySelector('[data-to-top-link]');
        this.init();
    }

    init() {
        this.initListeners();
    }

    initListeners() {
        window.addEventListener('scroll', () => {
            this.setVisible();
        });

        this.backToTopLink.addEventListener('click', () => {
            this.backToTop();
        });
    }

    setVisible() {
        const scroll = document.body.scrollTop || document.documentElement.scrollTop;

        if (scroll > this.offset) {
            this.container.classList.add('_visible');
        } else {
            if (this.container.classList.contains('_visible')) {
                this.container.classList.remove('_visible');
            }
        }
    }

    backToTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('[data-buttons-container]');
    if (container) {
        new buttonsContainer(container);
    }
})